import {
	connect
} from 'react-redux'
import FittingBatchComponent from '../components/FittingBatchComponent.jsx';
import {
	closeFittingBatchModal
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	showFittingBatchModal: state.getIn(['fittingReducer', 'showFittingBatchModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeFittingBatchModal());
	},
})

const FittingBatchContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FittingBatchComponent)

export default FittingBatchContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingBatchContainer.jsx